import { Button, Flex } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { ScoreCardEmptyDropdownMenuProps } from "./ScoreCardEmptyDropdownMenu.decl";

export function ScoreCardEmptyDropdownMenu({
  onCreateButtonClick,
}: ScoreCardEmptyDropdownMenuProps) {
  const { t } = useTranslation();
  return (
    <Flex p="m xl" flexDirection="column" gap="s" alignItems="center">
      <Button
        onClick={onCreateButtonClick}
        data-test="create-first-scorecard-button"
      >
        {t("score_card.create_first_scorecard")}
      </Button>
    </Flex>
  );
}
